var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9327,
    height: 21.9317,
    rx: 10.9659,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.446401,
    y: 0.446401,
    width: 21.0399,
    height: 21.0389,
    rx: 10.5195,
    stroke: "#373D46",
    strokeWidth: 0.892801
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.306 12.4364C16.306 13.2481 16.1197 13.9933 15.7471 14.672C15.3745 15.3374 14.8023 15.8764 14.0304 16.2889C13.2586 16.7014 12.3004 16.9077 11.156 16.9077H9.04009V21.9379H5.62671V7.92511H11.156C12.2738 7.92511 13.2187 8.11807 13.9905 8.50399C14.7623 8.88991 15.3412 9.42221 15.7271 10.1009C16.113 10.7796 16.306 11.5581 16.306 12.4364ZM10.8965 14.193C11.5486 14.193 12.0343 14.0399 12.3537 13.7338C12.673 13.4278 12.8327 12.9953 12.8327 12.4364C12.8327 11.8774 12.673 11.445 12.3537 11.1389C12.0343 10.8328 11.5486 10.6798 10.8965 10.6798H9.04009V14.193H10.8965Z",
    fill: "#373D46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3763 4.37503H5.62671V6.63018H16.3763V4.37503Z",
    fill: "#373D46"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkIcon);
export default __webpack_public_path__ + "static/media/dark_icon.ceab80bb34159e66415205e29750dd64.svg";
export { ForwardRef as ReactComponent };